import {
  GET_OFFER_REWARDS_RESPONSE,
  GET_VOUCHER_DETAILS_RESPONSE,
  GET_CREDIT_DETAILS_RESPONSE,
} from 'actions/offerRewards';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_REWARDS_RESPONSE:
      return {
        ...state,
        ...action.response.offerRewards,
      };
    case GET_VOUCHER_DETAILS_RESPONSE:
      return {
        ...state,
        basketVoucherDetails: {
          ...state.basketVoucherDetails,
          ...action.response.basketVoucherDetails,
        },
      };
    case GET_CREDIT_DETAILS_RESPONSE:
      return {
        ...state,
        creditDetails: {
          ...state.creditDetails,
          ...action.response.creditDetails,
        },
      };
    default:
      return state;
  }
};

export const selectBasketDiscount = state => state.basketDiscount;
export const selectBasketVoucherDetails = state => state.basketVoucherDetails;
export const selectCredit = state => state.credit;
export const selectCreditDetails = state => state.creditDetails;
export const selectCurrentMenuSlug = state => state.currentMenuSlug;
export const selectWeeklyBasket = state => state.weeklyBasket;
